/* ============================================================
   Rafeya Atelier — global.js
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const overlay = $('[data-overlay]');

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || 'LE {{amount}}';
    const amount = cents / 100;
    const withDecimals = amount.toLocaleString('en-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDecimals = Math.round(amount).toLocaleString('en-EG');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals);
  }

  /* ---------- overlay + drawers ---------- */
  let openEl = null;
  function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); } document.body.style.overflow = 'hidden'; }
  function hideOverlay() { if (overlay) { overlay.classList.remove('is-visible'); setTimeout(() => (overlay.hidden = true), 250); } document.body.style.overflow = ''; }
  function openPanel(el) { if (!el) return; closePanel(); el.classList.add('is-open'); el.removeAttribute('hidden'); el.setAttribute('aria-hidden', 'false'); openEl = el; showOverlay(); }
  function closePanel() { if (openEl) { openEl.classList.remove('is-open'); openEl.setAttribute('aria-hidden', 'true'); openEl = null; } hideOverlay(); }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-panel-open]');
    if (open) { e.preventDefault(); openPanel($('#' + open.getAttribute('data-panel-open'))); return; }
    if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closePanel(); return; }
    if (openEl && !e.target.closest('.drawer, .search-modal, .mobile-nav')) closePanel();
  });
  if (overlay) overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });

  /* ---------- mobile-nav accordion ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-acc-toggle]');
    if (!t) return;
    e.preventDefault();
    const item = t.closest('[data-acc]');
    if (!item) return;
    const open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- customer login: open recover view via #recover ---------- */
  if (location.hash === '#recover') {
    const lv = $('#login-view'), rv = $('#recover-view');
    if (lv && rv) { lv.hidden = true; rv.hidden = false; }
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = $('input', wrap);
    let v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + parseInt(btn.getAttribute('data-qty-change'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- hero carousel ---------- */
  $$('[data-carousel]').forEach((root) => {
    const slides = $$('[data-slide]', root);
    const dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.style.display = k === i ? '' : 'none'; });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('[data-arrow]'); const d = e.target.closest('[data-dot]');
      if (a) { go(i + parseInt(a.getAttribute('data-arrow'), 10)); reset(); }
      if (d) { go(dots.indexOf(d)); reset(); }
    });
    const reset = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), 6000); };
    go(0); reset();
  });

  /* ---------- made-to-measure module ---------- */
  const PROFILE_KEY = 'rafeya_measurements';
  function initMtm(root) {
    const fields = $$('[data-mtm-field]', root);
    // prefill from saved profile
    try {
      const saved = JSON.parse(localStorage.getItem(PROFILE_KEY) || '{}');
      fields.forEach((f) => { const k = f.getAttribute('data-mtm-field'); if (saved[k] && !f.value) f.value = saved[k]; });
    } catch (e) {}

    // unit toggle (cm <-> in)
    $$('[data-unit]', root).forEach((b) => b.addEventListener('click', () => {
      const unit = b.getAttribute('data-unit');
      $$('[data-unit]', root).forEach((x) => x.classList.toggle('is-on', x === b));
      fields.forEach((f) => {
        const cur = f.getAttribute('data-unit-state') || 'cm';
        if (!f.value) { f.setAttribute('data-unit-state', unit); setUnitLabel(f, unit); return; }
        let v = parseFloat(f.value); if (isNaN(v)) return;
        if (unit === 'in' && cur === 'cm') { f.value = (Math.round((v / 2.54) * 10) / 10); }
        if (unit === 'cm' && cur === 'in') { f.value = Math.round(v * 2.54); }
        f.setAttribute('data-unit-state', unit); setUnitLabel(f, unit);
      });
    }));
    function setUnitLabel(f, unit) { const lbl = f.parentElement.querySelector('[data-unit-label]'); if (lbl) lbl.textContent = unit; }

    // path pills
    $$('[data-path]', root).forEach((p) => p.addEventListener('click', () => {
      $$('[data-path]', root).forEach((x) => x.classList.toggle('is-on', x === p));
      const target = p.getAttribute('data-path');
      $$('[data-path-panel]', root).forEach((panel) => { panel.hidden = panel.getAttribute('data-path-panel') !== target; });
    }));

    // per-field measuring hint tooltips
    function closeTips() { $$('.mtm__tipwrap.is-open', root).forEach((w) => { w.classList.remove('is-open'); const t = w.querySelector('[data-tip-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }); }
    $$('[data-tip-toggle]', root).forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const wrap = b.closest('.mtm__tipwrap');
      const isOpen = wrap.classList.contains('is-open');
      closeTips();
      if (!isOpen) { wrap.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
    }));
    document.addEventListener('click', (e) => { if (!e.target.closest('.mtm__tipwrap')) closeTips(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeTips(); });

    // save to profile on change
    const save = $('[data-mtm-save]', root);
    fields.forEach((f) => f.addEventListener('change', () => {
      if (save && save.checked) {
        try {
          const data = JSON.parse(localStorage.getItem(PROFILE_KEY) || '{}');
          data[f.getAttribute('data-mtm-field')] = f.value;
          localStorage.setItem(PROFILE_KEY, JSON.stringify(data));
        } catch (e) {}
      }
    }));
  }
  $$('[data-mtm]').forEach(initMtm);

  /* ---------- variant / size selection ---------- */
  $$('[data-product-form]').forEach((form) => {
    $$('[data-option-name] input', form).forEach((inp) => inp.addEventListener('change', () => updateVariant(form)));
    updateVariant(form);
  });
  function updateVariant(form) {
    const dataEl = $('[data-variant-json]', form);
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const groups = $$('[data-option-name]', form);
    const selected = groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const match = variants.find((v) => selected.every((val, i) => val == null || v.options[i] === val));
    if (!match) return;
    const idField = $('[name="id"]', form);
    if (idField) idField.value = match.id;
    const addBtn = $('[data-add-btn]', form);
    if (addBtn) {
      addBtn.disabled = !match.available;
      const label = $('[data-add-label]', addBtn);
      if (label) label.textContent = match.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
    }
    const scope = form.closest('.pdp') || document;
    const priceEl = $('[data-price-target]', scope);
    if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
  }

  /* ---------- product gallery: slider + swipe + lightbox ---------- */
  $$('[data-gallery]').forEach(initGallery);

  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    if (!track) return;
    const n = $$('.pdp__slide', track).length;
    if (n === 0) return;
    const dots = $$('[data-gallery-dot]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const thumbStrip = $('.pdp__thumbs', root);
    let index = 0;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      if (thumbStrip && thumbs[index]) {
        const t = thumbs[index];
        thumbStrip.scrollLeft = Math.max(0, t.offsetLeft - (thumbStrip.clientWidth - t.clientWidth) / 2);
      }
    }
    function go(i) { index = (i + n) % n; render(); }

    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    swipe($('.pdp__viewport', root), track, () => index, go, n);
    dragScroll(thumbStrip);

    const lb = $('[data-lightbox]', root);
    if (lb) {
      const lbTrack = $('[data-lightbox-track]', lb);
      const counter = $('[data-lightbox-counter]', lb);
      let li = 0;
      function lbRender() {
        lbTrack.style.transform = 'translateX(' + (-li * 100) + '%)';
        if (counter) counter.textContent = (li + 1) + ' / ' + n;
      }
      function lbGo(i) { li = (i + n) % n; lbRender(); }
      function open() { li = index; lbRender(); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function close() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; go(li); }
      const zoom = $('[data-gallery-zoom]', root); if (zoom) zoom.addEventListener('click', open);
      const lp = $('[data-lightbox-prev]', lb); if (lp) lp.addEventListener('click', () => lbGo(li - 1));
      const ln = $('[data-lightbox-next]', lb); if (ln) ln.addEventListener('click', () => lbGo(li + 1));
      const lc = $('[data-lightbox-close]', lb); if (lc) lc.addEventListener('click', close);
      lb.addEventListener('click', (e) => { if (e.target === lb || (e.target.classList && e.target.classList.contains('lightbox__viewport'))) close(); });
      document.addEventListener('keydown', (e) => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') lbGo(li + 1);
        else if (e.key === 'ArrowLeft') lbGo(li - 1);
      });
      swipe($('.lightbox__viewport', lb), lbTrack, () => li, lbGo, n);
    }
    render();
  }

  function swipe(viewport, track, get, go, n) {
    if (!viewport || n < 2) return;
    let sx = 0, drag = false, d = 0, w = 0;
    viewport.addEventListener('pointerdown', (e) => {
      if (e.target.closest('button')) return;
      drag = true; sx = e.clientX; d = 0; w = viewport.offsetWidth || track.offsetWidth;
      track.classList.add('is-dragging');
      try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
    });
    viewport.addEventListener('pointermove', (e) => {
      if (!drag) return;
      d = e.clientX - sx;
      track.style.transform = 'translateX(calc(' + (-get() * 100) + '% + ' + d + 'px))';
    });
    function end() {
      if (!drag) return;
      drag = false;
      track.classList.remove('is-dragging');
      const i = get();
      if (Math.abs(d) > Math.min(w * 0.15, 80)) go(d < 0 ? i + 1 : i - 1);
      else go(i);
      d = 0;
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
  }

  function dragScroll(el) {
    if (!el) return;
    let down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      down = true; sx = e.clientX; sl = el.scrollLeft; moved = false; el.classList.add('is-grabbing');
    });
    el.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - sx;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = sl - dx;
    });
    const up = () => { if (down) { down = false; el.classList.remove('is-grabbing'); } };
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', (e) => e.preventDefault());
  }

  /* ---------- colour swatch fallback (invalid CSS colour name) ---------- */
  $$('.pdp__swatch-color').forEach((s) => {
    if (getComputedStyle(s).backgroundColor === 'rgba(0, 0, 0, 0)') s.style.background = '#c9d6d3';
  });

  /* ---------- wishlist (localStorage) ---------- */
  function updateWishlistBadges() {
    let n = 0;
    try { n = (JSON.parse(localStorage.getItem('rafeya_wishlist') || '[]') || []).length; } catch (e) {}
    $$('[data-wishlist-badge]').forEach((b) => { b.textContent = n; b.hidden = n === 0; });
  }
  (function () {
    const KEY = 'rafeya_wishlist';
    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    $$('[data-wishlist]').forEach((w) => { if (list.indexOf(w.getAttribute('data-wishlist')) >= 0) w.classList.add('is-wished'); });
    updateWishlistBadges();
    document.addEventListener('click', (e) => {
      const w = e.target.closest('[data-wishlist]');
      if (!w) return;
      e.preventDefault();
      const id = w.getAttribute('data-wishlist');
      const i = list.indexOf(id);
      if (i >= 0) { list.splice(i, 1); w.classList.remove('is-wished'); }
      else { list.push(id); w.classList.add('is-wished'); }
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      updateWishlistBadges();
    });
  })();

  /* ---------- wishlist page ---------- */
  (function () {
    const page = $('[data-wishlist-page]');
    if (!page) return;
    const KEY = 'rafeya_wishlist';
    const grid = $('[data-wishlist-grid]', page);
    const empty = $('[data-wishlist-empty]', page);
    const loading = $('[data-wishlist-loading]', page);
    const countEl = $('[data-wishlist-count]', page);
    const HEART = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.6-7-9.5A3.5 3.5 0 0 1 12 7a3.5 3.5 0 0 1 7 3.5C19 15.4 12 20 12 20Z"/></svg>';
    const RULER = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="8" rx="1"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';
    const CLOSE = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';

    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    handles = handles.filter(Boolean).filter((h, i, a) => a.indexOf(h) === i);

    const esc = (s) => (s == null ? '' : String(s)).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const imgUrl = (src, w) => { if (!src) return ''; const u = src.indexOf('//') === 0 ? 'https:' + src : src; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; };
    const setCount = (n) => { if (countEl) countEl.textContent = n ? (n + (n === 1 ? ' saved piece' : ' saved pieces')) : ''; };
    function showEmpty() { if (loading) loading.hidden = true; if (grid) grid.hidden = true; if (empty) empty.hidden = false; if (countEl) countEl.textContent = ''; }

    if (!handles.length) { showEmpty(); return; }

    function cardHTML(p) {
      const h = p.handle;
      const url = '/products/' + h;
      const eyebrow = p.type || p.vendor || '';
      const onSale = p.compare_at_price && p.compare_at_price > p.price;
      const discount = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
      const img = p.featured_image
        ? '<img src="' + imgUrl(p.featured_image, 600) + '" alt="' + esc(p.title) + '" width="600" height="900" loading="lazy">'
        : '<span class="ph" style="position:absolute;inset:0"></span>';
      let badge2 = '';
      if (p.available === false) badge2 = '<span class="badge badge--soldout">Sold out</span>';
      else if (onSale) badge2 = '<span class="badge badge--sale">−' + discount + '%</span>';
      else if ((p.tags || []).indexOf('new') >= 0) badge2 = '<span class="badge badge--new">New</span>';
      let price;
      if (onSale) price = '<span class="price--sale">' + formatMoney(p.price) + '</span> <span class="price--compare">' + formatMoney(p.compare_at_price) + '</span>';
      else if (p.price_varies) price = '<span>From ' + formatMoney(p.price_min) + '</span>';
      else price = '<span>' + formatMoney(p.price) + '</span>';
      return '<article class="product-card" data-card-handle="' + esc(h) + '">'
        + '<div class="product-card__media-wrap">'
        + '<a href="' + url + '" class="product-card__media" aria-label="' + esc(p.title) + '">' + img
        + '<span class="product-card__badges">' + badge2 + '</span></a>'
        + '<button type="button" class="product-card__wish is-wished" data-wishlist="' + esc(h) + '" aria-label="Remove from wishlist">' + HEART + '</button>'
        + '</div>'
        + '<div class="product-card__info">'
        + (eyebrow ? '<div class="product-card__vendor">' + esc(eyebrow) + '</div>' : '')
        + '<a href="' + url + '"><h3 class="product-card__title">' + esc(p.title) + '</h3></a>'
        + '<div class="product-card__price">' + price + '</div>'
        + '<div class="product-card__mtm">' + RULER + ' Made to measure</div>'
        + '<button type="button" class="wishlist-card__remove" data-wishlist="' + esc(h) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + CLOSE + 'Remove</button>'
        + '</div></article>';
    }

    Promise.all(handles.map((h) =>
      fetch('/products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)
    )).then((products) => {
      const valid = products.filter(Boolean);
      const validHandles = valid.map((p) => p.handle);
      if (validHandles.length !== handles.length) {
        try { localStorage.setItem(KEY, JSON.stringify(validHandles)); } catch (e) {}
        updateWishlistBadges();
      }
      if (!valid.length) { showEmpty(); return; }
      grid.innerHTML = valid.map(cardHTML).join('');
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = true;
      grid.hidden = false;
      setCount(valid.length);
    });

    page.addEventListener('click', (e) => {
      const w = e.target.closest('[data-wishlist]');
      if (!w) return;
      setTimeout(() => {
        if (!w.classList.contains('is-wished')) {
          const card = w.closest('[data-card-handle]');
          if (card) card.remove();
          const remaining = $$('[data-card-handle]', grid).length;
          setCount(remaining);
          if (!remaining) showEmpty();
        }
      }, 0);
    });
  })();

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    if (!form.reportValidity()) return;
    const btn = $('[data-add-btn]', form);
    if (btn) btn.classList.add('is-loading');
    try {
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formToCartPayload(form))
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Add failed'); }
      await refreshCart();
      openPanel($('#CartDrawer'));
    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally { if (btn) btn.classList.remove('is-loading'); }
  });

  /* ---------- buy it now (instant checkout) ---------- */
  document.addEventListener('click', async (e) => {
    const bn = e.target.closest('[data-buy-now]');
    if (!bn || bn.hasAttribute('disabled') || bn.classList.contains('is-loading')) return;
    const form = bn.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    if (!form.reportValidity()) return;
    bn.classList.add('is-loading');
    try {
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formToCartPayload(form))
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Add failed'); }
      window.location.href = '/checkout';
    } catch (err) { console.error(err); alert(err.message); bn.classList.remove('is-loading'); }
  });

  /* ---------- share: native share / copy link ---------- */
  document.addEventListener('click', async (e) => {
    const c = e.target.closest('[data-share-copy]');
    if (!c) return;
    e.preventDefault();
    const url = c.getAttribute('data-share-copy');
    try {
      if (navigator.share && window.matchMedia('(max-width:749px)').matches) { await navigator.share({ url }); return; }
      await navigator.clipboard.writeText(url);
      c.classList.add('is-copied');
      setTimeout(() => c.classList.remove('is-copied'), 1400);
    } catch (err) { /* cancelled or unsupported */ }
  });

  /* ---------- order tracking: courier lookup ---------- */
  function trackCourier(go) {
    const wrap = go.closest('[data-track-courier]');
    const input = wrap && wrap.querySelector('[data-track-input]');
    const val = input && input.value.trim();
    if (!val) { if (input) input.focus(); return; }
    const base = go.getAttribute('data-track-base');
    if (!base) return;
    const url = base.indexOf('{number}') >= 0 ? base.replace('{number}', encodeURIComponent(val)) : base + encodeURIComponent(val);
    window.open(url, '_blank', 'noopener');
  }
  document.addEventListener('click', (e) => {
    const go = e.target.closest('[data-track-go]');
    if (go) trackCourier(go);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('[data-track-input]');
    if (!input) return;
    const go = input.closest('[data-track-courier]').querySelector('[data-track-go]');
    if (go) { e.preventDefault(); trackCourier(go); }
  });

  /* ---------- cart order note: save on change ---------- */
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(window.theme.routes.cart_url + '/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(() => {});
  });

  function formToCartPayload(form) {
    const fd = new FormData(form);
    const payload = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10), properties: {} };
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v) payload.properties[m[1]] = v;
    }
    if (Object.keys(payload.properties).length === 0) delete payload.properties;
    return payload;
  }

  /* ---------- cart drawer rendering from /cart.js ---------- */
  async function refreshCart() {
    const res = await fetch(window.theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
  }
  window.RafeyaRefreshCart = refreshCart;

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const body = $('#CartDrawerBody');
    const foot = $('#CartDrawerFoot');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p><button class="btn btn--ghost" data-panel-close>Continue shopping</button></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(cartItemHTML).join('');
    const sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  function cartItemHTML(item) {
    const props = (item.properties || {});
    const measure = Object.keys(props).filter((k) => k.indexOf('_') !== 0 && props[k] && k !== 'Notes' && props[k] !== 'As Shown');
    const measureHTML = measure.length
      ? '<div class="cart-item__mtm"><span>✓</span><span>' + measure.map((k) => esc(k.replace(/^Measure /, '')) + ' ' + esc(props[k])).join(' · ') + '</span></div>'
      : '';
    const img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_128x192_crop_center$1$2') + '" alt="' + esc(item.product_title) + '">' : '';
    return '<div class="cart-item" data-key="' + item.key + '">' +
      '<div class="cart-item__media">' + img + '</div>' +
      '<div><div class="cart-item__title">' + esc(item.product_title) + '</div>' +
      '<div class="cart-item__meta">' + esc(item.variant_title || '') + '</div>' +
      measureHTML +
      '<div class="qty" data-qty style="margin-top:8px"><button data-cart-qty="-1" data-key="' + item.key + '" aria-label="Decrease">&minus;</button><input value="' + item.quantity + '" readonly><button data-cart-qty="1" data-key="' + item.key + '" aria-label="Increase">+</button></div>' +
      '</div>' +
      '<div style="text-align:end"><div>' + formatMoney(item.final_line_price) + '</div>' +
      '<button class="link-underline" data-cart-remove="' + item.key + '" style="border:0;margin-top:8px;color:var(--muted)">Remove</button></div>' +
      '</div>';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-cart-qty]');
    const rm = e.target.closest('[data-cart-remove]');
    if (!q && !rm) return;
    e.preventDefault();
    let key, qty;
    if (rm) { key = rm.getAttribute('data-cart-remove'); qty = 0; }
    else {
      key = q.getAttribute('data-key');
      const input = q.parentElement.querySelector('input');
      qty = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-cart-qty'), 10));
    }
    const res = await fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    renderCart(await res.json());
  });

  /* ---------- predictive search ---------- */
  (function () {
    const input = $('[data-predictive-input]');
    if (!input) return;
    const results = $('[data-predictive-results]');
    const hint = $('.psr-hint');
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; if (hint) hint.hidden = false; return; }
      t = setTimeout(async () => {
        try {
          const url = window.theme.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
          const data = await fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          renderPredictive((data.resources && data.resources.results) || {});
        } catch (e) {}
      }, 220);
    });
    function renderPredictive(r) {
      const products = r.products || [];
      const collections = r.collections || [];
      if (!products.length && !collections.length) {
        results.innerHTML = '<p style="color:var(--muted);font-size:13px;padding:10px 0">No matches yet.</p>';
        results.hidden = false; if (hint) hint.hidden = true; return;
      }
      let html = '';
      if (products.length) {
        html += '<div class="psr__group">Pieces</div>';
        html += products.map((p) => {
          const src = (p.featured_image && p.featured_image.url) || p.image;
          const img = src ? '<img class="psr__img" src="' + src + '" alt="" width="48" height="60">' : '<span class="psr__img"></span>';
          return '<a href="' + p.url + '">' + img + '<span><span class="psr__t">' + esc(p.title) + '</span><br><span class="psr__p">' + (p.price || '') + '</span></span></a>';
        }).join('');
      }
      if (collections.length) {
        html += '<div class="psr__group">Collections</div>';
        html += collections.map((c) => '<a href="' + c.url + '"><span class="psr__t">' + esc(c.title) + '</span></a>').join('');
      }
      results.innerHTML = html; results.hidden = false; if (hint) hint.hidden = true;
    }
  })();

  /* ---------- account: size passport ---------- */
  (function () {
    const root = $('[data-size-passport]');
    if (!root) return;
    const KEY = 'rafeya_measurements';
    const fields = $$('[data-mtm-field]', root);
    let saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
    fields.forEach((f) => { const k = f.getAttribute('data-mtm-field'); if (saved[k]) f.value = saved[k]; });
    const status = $('[data-passport-status]', root);
    const flash = (msg) => { if (status) { status.textContent = msg; setTimeout(() => { status.textContent = ''; }, 2000); } };
    const saveBtn = $('[data-passport-save]', root);
    const clearBtn = $('[data-passport-clear]', root);
    if (saveBtn) saveBtn.addEventListener('click', () => {
      const data = {};
      fields.forEach((f) => { if (f.value) data[f.getAttribute('data-mtm-field')] = f.value; });
      localStorage.setItem(KEY, JSON.stringify(data));
      flash('Saved ✓');
    });
    if (clearBtn) clearBtn.addEventListener('click', () => {
      localStorage.removeItem(KEY);
      fields.forEach((f) => { f.value = ''; });
      flash('Cleared');
    });
  })();

  /* ---------- collections list: group filter pills ---------- */
  $$('[data-group-tabs]').forEach((tabs) => {
    const section = tabs.closest('section');
    const grid = section && section.querySelector('[data-group-grid]');
    tabs.addEventListener('click', (e) => {
      const p = e.target.closest('[data-group-pill]');
      if (!p || !grid) return;
      $$('[data-group-pill]', tabs).forEach((x) => x.classList.toggle('is-on', x === p));
      const g = p.getAttribute('data-group-pill');
      $$('[data-group]', grid).forEach((c) => {
        const cg = (c.getAttribute('data-group') || '').toLowerCase();
        c.style.display = (g === 'all' || cg.indexOf(g) >= 0) ? '' : 'none';
      });
    });
  });

  /* ---------- recently viewed ---------- */
  (function () {
    const section = $('[data-recently-viewed]');
    if (!section) return;
    const RV_KEY = 'rafeya_recently_viewed';
    const cur = section.getAttribute('data-current-handle');
    const max = parseInt(section.getAttribute('data-max') || '4', 10);
    const grid = $('[data-recently-grid]', section);
    let list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    list = list.filter(Boolean);
    const toShow = (cur ? list.filter((h) => h !== cur) : list).slice(0, max);
    if (cur) {
      list = [cur].concat(list.filter((h) => h !== cur)).slice(0, 16);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
    }
    if (!toShow.length || !grid) return;

    const esc = (s) => (s == null ? '' : String(s)).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const imgUrl = (src, w) => { if (!src) return ''; const u = src.indexOf('//') === 0 ? 'https:' + src : src; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; };
    const RULER = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="8" rx="1"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';
    const HEART = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.6-7-9.5A3.5 3.5 0 0 1 12 7a3.5 3.5 0 0 1 7 3.5C19 15.4 12 20 12 20Z"/></svg>';
    function cardHTML(p) {
      const h = p.handle; const url = '/products/' + h;
      const eyebrow = p.type || p.vendor || '';
      const onSale = p.compare_at_price && p.compare_at_price > p.price;
      const discount = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
      const img = p.featured_image
        ? '<img src="' + imgUrl(p.featured_image, 600) + '" alt="' + esc(p.title) + '" width="600" height="900" loading="lazy">'
        : '<span class="ph" style="position:absolute;inset:0"></span>';
      let badge2 = '';
      if (p.available === false) badge2 = '<span class="badge badge--soldout">Sold out</span>';
      else if (onSale) badge2 = '<span class="badge badge--sale">−' + discount + '%</span>';
      else if ((p.tags || []).indexOf('new') >= 0) badge2 = '<span class="badge badge--new">New</span>';
      let price;
      if (onSale) price = '<span class="price--sale">' + formatMoney(p.price) + '</span> <span class="price--compare">' + formatMoney(p.compare_at_price) + '</span>';
      else if (p.price_varies) price = '<span>From ' + formatMoney(p.price_min) + '</span>';
      else price = '<span>' + formatMoney(p.price) + '</span>';
      return '<article class="product-card">'
        + '<div class="product-card__media-wrap">'
        + '<a href="' + url + '" class="product-card__media" aria-label="' + esc(p.title) + '">' + img
        + '<span class="product-card__badges">' + badge2 + '</span></a>'
        + '<button type="button" class="product-card__wish" data-wishlist="' + esc(h) + '" aria-label="Save to wishlist">' + HEART + '</button>'
        + '</div>'
        + '<div class="product-card__info">'
        + (eyebrow ? '<div class="product-card__vendor">' + esc(eyebrow) + '</div>' : '')
        + '<a href="' + url + '"><h3 class="product-card__title">' + esc(p.title) + '</h3></a>'
        + '<div class="product-card__price">' + price + '</div>'
        + '<div class="product-card__mtm">' + RULER + ' Made to measure</div>'
        + '</div></article>';
    }
    Promise.all(toShow.map((h) =>
      fetch('/products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)
    )).then((products) => {
      const valid = products.filter(Boolean);
      if (!valid.length) return;
      grid.innerHTML = valid.map(cardHTML).join('');
      section.hidden = false;
      let wl = [];
      try { wl = JSON.parse(localStorage.getItem('rafeya_wishlist') || '[]'); } catch (e) {}
      $$('[data-wishlist]', grid).forEach((w) => { if (wl.indexOf(w.getAttribute('data-wishlist')) >= 0) w.classList.add('is-wished'); });
    });
  })();

  /* ---------- back to top ---------- */
  (function () {
    const btn = $('[data-back-to-top]');
    if (!btn) return;
    const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 500);
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
    btn.addEventListener('click', () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
      const step = () => {
        const pos = Math.max(0, window.scrollY - Math.max(40, window.scrollY * 0.18));
        window.scrollTo(0, pos);
        if (pos > 0) setTimeout(step, 16);
      };
      step();
    });
  })();

  /* ---------- Shopify chat ("Need help?"): lift the launcher above the back-to-top button ---------- */
  (function () {
    // Shopify's storefront chat renders as <shopify-chat> (shadow DOM). Its launcher position is driven
    // by the app's own inline custom property --shopify-agent-activator-offset (set !important), so only
    // an inline !important override on the host wins. Raise it clear of the back-to-top button:
    //   desktop back-to-top = bottom:24px + 46px  -> lift to 84px
    //   mobile  back-to-top = bottom:74px(+safe) + 42px -> lift to 130px + safe-area
    function wantOffset(){
      return window.matchMedia('(max-width:749px)').matches
        ? 'calc(130px + env(safe-area-inset-bottom))'
        : '84px';
    }
    function apply(){
      var host=document.querySelector('shopify-chat'); if(!host) return false;
      var want=wantOffset();
      // already ours? skip — this keeps the MutationObserver below from looping on our own write.
      if(host.style.getPropertyValue('--shopify-agent-activator-offset')===want
         && host.style.getPropertyPriority('--shopify-agent-activator-offset')==='important') return true;
      host.style.setProperty('--shopify-agent-activator-offset', want, 'important');
      // the app may rewrite its inline style (open/close, view change) — re-apply when it does.
      if(!host.__rafeyaOffsetObs){
        host.__rafeyaOffsetObs=new MutationObserver(function(){ apply(); });
        host.__rafeyaOffsetObs.observe(host,{attributes:true,attributeFilter:['style']});
      }
      return true;
    }
    if(!apply()){ var n=0, iv=setInterval(function(){ if(apply()||++n>60) clearInterval(iv); },400); }
    window.addEventListener('resize', apply);
  })();
})();
